import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt, FaUserFriends, FaGlassCheers, FaClock } from "react-icons/fa";


function BookingPage({ availableTimes = [], updateTimes, submitForm }) {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState("");
  const [numDiners, setNumDiners] = useState("2");
  const [occasion, setOccasion] = useState("");
  const [dateError, setDateError] = useState("");
  const [timeError, setTimeError] = useState("");
  const [dinersError, setDinersError] = useState("");
  const [occasionError, setOccasionError] = useState("");

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setDateError(!date ? "Please select a date." : "");
    if (typeof updateTimes === "function") {
      updateTimes({ type: "UPDATE", payload: date });
    } else {
      console.error("❌ ERROR: updateTimes is not a function");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasErrors = false;

    if (!selectedDate) {
      setDateError("Please select a date.");
      hasErrors = true;
    }
    if (!selectedTime) {
      setTimeError("Please select a time.");
      hasErrors = true;
    }
    if (!numDiners) {
      setDinersError("Please select the number of diners.");
      hasErrors = true;
    }
    if (!occasion) {
      setOccasionError("Please select an occasion.");
      hasErrors = true;
    }

    if (!hasErrors) {
      const formData = {
        date: selectedDate,
        time: selectedTime,
        guests: numDiners,
        occasion: occasion,
      };
      submitForm(formData);
    }
  };

  const isSubmitDisabled = !selectedDate || !selectedTime || !numDiners || !occasion;


  return (
    <section className="booking-banner">
        <div className="booking-content">
            <div className="booking-text">
                <h1 id="booking-title">Reserve a Table</h1>
                <p id="booking-subtitle">
                    Enjoy a memorable dining experience at Little Lemon
                </p>

                <form onSubmit={handleSubmit} className="booking-form">
                    <label htmlFor="date">
                    <FaCalendarAlt style={{ marginRight: "8px" }} />
                        Select a Date:

                    </label>
                    <div className="date-picker-container">
                        <DatePicker
                            selected={selectedDate}
                            onChange={handleDateChange}
                            minDate={new Date()}
                            placeholderText="Select a date"
                            id="date"
                            required
                        />
                    </div>
                    {dateError && <p className="error">{dateError}</p>}

                    <label htmlFor="diners">
                    <FaUserFriends style={{ marginRight: "8px" }} />
                        Number of Diners:</label>
                    <div className="select-container diners">
                        <select
                            name="diners"
                            value={numDiners}
                            onChange={(e) => setNumDiners(e.target.value)}
                            required
                        >
                            <option value="">-- Select Diners --</option>
                            {[1, 2, 4, 6].map((num) => (
                                <option key={num} value={num}>
                                    {num} {num === 1 ? "person" : "people"}
                                </option>
                            ))}
                        </select>
                    </div>
                    {dinersError && <p className="error">{dinersError}</p>}

                    <label htmlFor="time">
                    <FaClock style={{ marginRight: "8px" }} />
                        Select a Time:</label>
                    <div className="select-container">
                        <select
                            value={selectedTime}
                            onChange={(e) => setSelectedTime(e.target.value)}
                            id="time"
                            required
                        >
                            <option value="">-- Select Time --</option>
                            {availableTimes.length > 0 ? (
                                availableTimes.map((time) => (
                                    <option key={time} value={time}>
                                        {time}
                                    </option>
                                ))
                            ) : (
                                <option disabled>No available times</option>
                            )}
                        </select>
                    </div>
                    {timeError && <p className="error">{timeError}</p>}

                    <label htmlFor="occasion">
                    <FaGlassCheers style={{ marginRight: "8px" }} />
                        Occasion:</label>
                    <div className="select-container">
                        <select
                            value={occasion}
                            onChange={(e) => setOccasion(e.target.value)}
                            id="occasion"
                            required
                        >
                            <option value="">-- Select Occasion --</option>
                            <option value="Birthday">Birthday</option>
                            <option value="Anniversary">Anniversary</option>
                            <option value="Engagement">Engagement</option>
                        </select>
                    </div>
                    {occasionError && <p className="error">{occasionError}</p>}

                    <button
                        className="cta-button"
                        type="submit"
                        disabled={isSubmitDisabled}
                    >
                        Confirm Reservation
                    </button>
                </form>
            </div>
            <div className="booking-pic">
                <img src="/pexels-max-griss-16866522-13669062.jpg" alt="Restaurant" />
            </div>
        </div>
    </section>
);
}

export default BookingPage;